document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector('form[data-type="add-to-cart-form"]');

  if (!form) return;

  const variantInput = document.querySelector(".product-variant-id");

  const variants = JSON.parse(
    document.getElementById("ProductVariants").textContent
  );

  const optionButtons = document.querySelectorAll(".option-btn");

  function updateVariant() {
    const color = document.getElementById("color")?.value;
    const size = document.getElementById("size")?.value;

    if (!color || !size) return;

    const matchedVariant = variants.find((variant) => {
      return (
        variant.option1 === size &&
        variant.option2 === color
      );
    });

    if (matchedVariant) {
      variantInput.value = matchedVariant.id;
      console.log("Selected Variant:", matchedVariant);
    }
  }

  optionButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const group = this.dataset.group;
      const value = this.dataset.value;

      document
        .querySelectorAll(`.option-btn[data-group="${group}"]`)
        .forEach((btn) => btn.classList.remove("active"));

      this.classList.add("active");

      const input = document.getElementById(group);

      if (input) {
        input.value = value;
      }

      const groupWrap = this.closest(".option-group");

      if (groupWrap) {
        groupWrap.classList.remove("error");
      }

      // NEW
      updateVariant();
    });
  });

  form.addEventListener("submit", function (e) {
    const requiredFields = [
      "gender",
      "garment",
      "toe",
      "style",
      "compression",
      "color",
      "size",
    ];

    let valid = true;

    requiredFields.forEach((id) => {
      const input = document.getElementById(id);

      if (!input || input.value === "") {
        valid = false;

        const button = document.querySelector(
          `.option-btn[data-group="${id}"]`
        );

        if (button) {
          button.closest(".option-group").classList.add("error");
        }
      }
    });

    if (!valid) {
      e.preventDefault();
      alert("Please select all product options before adding to cart.");
      return;
    }

    updateVariant();
  });
});

/* Compression Guide Modal */
const guideLink = document.querySelector(".js-open-compression-guide");
const guideModal = document.querySelector(".compression-guide-modal");

if (guideLink && guideModal) {
  const overlay = guideModal.querySelector(".compression-guide-modal__overlay");
  const closeBtn = guideModal.querySelector(".compression-guide-modal__close");

  guideLink.addEventListener("click", function (e) {
    e.preventDefault();

    guideModal.classList.add("active");

    document.body.style.overflow = "hidden";
  });

  function closeGuide() {
    guideModal.classList.remove("active");

    document.body.style.overflow = "";
  }

  overlay.addEventListener("click", closeGuide);

  closeBtn.addEventListener("click", closeGuide);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeGuide();
    }
  });
}

/* Size Guide Modal */
const size_guideLink = document.querySelector(".js-open-size-guide");
const size_guideModal = document.querySelector(".size-guide-modal");

if (size_guideLink && size_guideModal) {
  const overlay = size_guideModal.querySelector(".size-guide-modal__overlay");
  const closeBtn = size_guideModal.querySelector(".size-guide-modal__close");

  size_guideLink.addEventListener("click", function (e) {
    e.preventDefault();

    size_guideModal.classList.add("active");

    document.body.style.overflow = "hidden";
  });

  function closeSizeGuide() {
    size_guideModal.classList.remove("active");

    document.body.style.overflow = "";
  }

  overlay.addEventListener("click", closeSizeGuide);

  closeBtn.addEventListener("click", closeSizeGuide);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeSizeGuide();
    }
  });
}